
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Edit, Save, X } from 'lucide-react';

interface EditableTextAreaProps {
  label: string;
  value: string;
  name: string;
  onSave: (value: string) => void;
  className?: string;
  rows?: number;
}

export const EditableTextArea: React.FC<EditableTextAreaProps> = ({
  label,
  value,
  name,
  onSave,
  className = "",
  rows = 4
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  
  const handleSave = () => {
    onSave(localValue);
    setIsEditing(false);
  };
  
  const handleCancel = () => {
    setLocalValue(value);
    setIsEditing(false);
  };
  
  if (!isEditing) {
    return (
      <div className={`relative group ${className}`}>
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <Label className="block text-sm text-muted-foreground mb-1">{label}</Label>
            <div className="font-medium whitespace-pre-wrap">{value}</div>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => setIsEditing(true)}
            className="h-7 w-7 p-0 opacity-0 group-hover:opacity-100 transition-opacity ml-2"
          >
            <Edit className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    );
  }
  
  return (
    <div className={`space-y-2 ${className}`}>
      <Label htmlFor={name}>{label}</Label>
      <Textarea
        id={name}
        name={name}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        rows={rows}
      />
      <div className="flex justify-end gap-2 mt-1">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleCancel}
        >
          <X className="h-3.5 w-3.5 mr-1" />
          Cancel
        </Button>
        <Button 
          size="sm" 
          onClick={handleSave}
        >
          <Save className="h-3.5 w-3.5 mr-1" />
          Save
        </Button>
      </div>
    </div>
  );
};
